import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

import { isExternal } from '@/tools/validate';
import { state as globalState } from '@/modules/global';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
  /** 图标名称 */
  icon: {
    type: String,
    required: true,
  },
  /** 类名 */
  className: {
    type: String,
    default: '',
  },
  /** 图标大小 */
  size: {
    type: String,
    default: '14px',
  },
  /** 颜色 */
  color: {
    type: String,
    default: '',
  },
  /** 光标悬浮颜色 */
  hoverColor: {
    type: String,
    default: '',
  },
  /** 目录key 判断当前key来判断是否高亮显示 */
  openKey: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {

const props = __props;



/** 判断是否以http(s)/mailto/tel为开头 */
const isExternalA = isExternal(props.icon);
/** 真实SVG图标名称 */
const iconName = `#icon-${props.icon}`;

const svgClass = computed(() => {
  if (props.className) {
    return `svg-icon ${props.className}`;
  } else {
    return 'svg-icon';
  }
});

/** 选中目录的时候样式改变 */
const selectSty = computed(() => {
  return props.openKey === globalState.topFatherId
    ? 'filter: invert(51%) sepia(22%) saturate(7491%) hue-rotate(214deg) brightness(105%) contrast(101%)'
    : '';
});

const getStyleExternalIcon = () => {
  return {
    mask: `url(${props.icon}) no-repeat 50% 50%`,
    '-webkit-mask': `url(${props.icon}) no-repeat 50% 50%`,
  };
};

const styleHover = computed(() => {
  return {
    '--icon-color': props.color,
    '--icon-color-hover': props.hoverColor,
  };
});

const styleExternalIcon = getStyleExternalIcon();

return (_ctx: any,_cache: any) => {
  return (_unref(isExternalA))
    ? (_openBlock(), _createElementBlock("div", _mergeProps({
        key: 0,
        style: _unref(styleExternalIcon),
        class: "svg-external-icon svg-icon"
      }, _ctx.$attrs), null, 16))
    : (_openBlock(), _createElementBlock("svg", _mergeProps({
        key: 1,
        class: _unref(svgClass),
        "aria-hidden": "true"
      }, _ctx.$attrs, {
        style: { fontSize: __props.size, width: __props.size, height: __props.size, ..._unref(styleHover) }
      }), [
        _createElementVNode("use", {
          "xlink:href": iconName,
          style: _normalizeStyle(_unref(selectSty))
        }, null, 4)
      ], 16))
}
}

})